import './footer.css';

export default function Footer() {
  return (
    <div id='footer'>
      <p>All right reserved by Khizar Ali &reg;</p>
    </div>
  )
}